import { useEffect } from 'react';

import useApiQuery from 'lib/api/useApiQuery';
import { HOMEPAGE_STATS } from 'stubs/stats';

const listTokensPrice =
[
  {
    address: '0xd79D8Fa7B9E4eE8a4a2fFA1744C9f480096e9684',
    price: '0.9998',
  },
  {
    address: '0x42A74a2029fF7D95184e512a12B12079B8ed92Ba',
    price: '0.9998',
  },
  {
    address: '0xDD5cEB3011218171D76fFd8b1F72985a47CCf15d',
    price: '0.9999',
  },
  {
    address: '0xe83CA8B972955d0F6535a335D9549A873aF3c170',
    price: '0.9999',
  },
  {
    address: '0xb78E2642b875928254cF50683D0589ca249f4efc',
    price: '0.9998',
  },
  {
    address: '0xfE5f4FA42e7A3027475A3Eb54F7eE16c332298f1',
    price: '0.9999',
  } ];

export default function FixPriceForToken(addressName: string) {
  const statsQuery = useApiQuery('homepage_stats', {
    queryOptions: {
      placeholderData: HOMEPAGE_STATS,
    },
  });
  useEffect(() => {
    if (addressName === '0x3F7BE9DB9d37bd89c3Fa722BB29bA17300C18fc8') {
      const fetchPrice = () => {
        const itemValue = statsQuery.data?.coin_price;
        if (!itemValue) {
          return '';
        }
        if (itemValue === '0') {
          return itemValue;
        }
        return itemValue;
      };

      const item = {
        address: '0x3F7BE9DB9d37bd89c3Fa722BB29bA17300C18fc8',
        price: fetchPrice(),
      };

      listTokensPrice.push(item);
    }
  }, [ statsQuery, addressName ]);

  const valueAddress = listTokensPrice.find((x) => x.address.includes(addressName));

  return valueAddress?.price ? valueAddress?.price : null;
}
